import React, { Component } from "react";
import {  Loader, Icon, Message, Pagination, Input, Form, Table, Button, Divider, Header} from 'semantic-ui-react'
import { invokeApig, downloadS3Text, uploadS3Text } from "../libs/awsLib";
import config from "../config";
import _ from 'lodash';

const PAGE_SIZE=10;
const NO_PAGES=100;

export default class AnomalyDetectionThresholds extends Component {
  constructor(props) {
    super(props);

    
    this.state={data: {}, activePage: 1, loading: true, uploadSuccess: false, uploadFailed: false, };

  }


  
  componentDidMount()
  {
    this.loadContent();
    
  }


  loadContent()
  {
    const bucket=config.smartAdapterS3Bucket;
    const key='anomalydetectionthresholds.json'
    downloadS3Text(bucket, key).then(result=>{console.log(result); this.setState({data: result, loading: false})})
  }
  saveContent()
  {
    const bucket=config.smartAdapterS3Bucket;
    const key='anomalydetectionthresholds.json'
    //update json 
    uploadS3Text(bucket, key, this.state.data).then(result=>{this.setState({uploadSuccess: true, uploadFailed: false, validationErrors: []})}).catch(result=>{this.setState({uploadSuccess: false, uploadFailed: true, validationErrors: ['Failed to save confguration']})})
  }

  updateWarningThreshold(srv, value) {
    var copyData=_.cloneDeep(this.state.data);
    copyData[srv].warningThreshold=value;
    this.setState({data: copyData})
  }

  updateQuarantineThreshold(srv, value) {
    var copyData=_.cloneDeep(this.state.data);
    copyData[srv].quarantineThreshold=value;
    this.setState({data: copyData})
  }


 render() {

    
    //handle pagination
    var activePage=this.state.activePage;
    var srvs=Object.keys(this.state.data);
    if (srvs.length<(activePage-1)*PAGE_SIZE)
    {
      activePage=1;
      this.setState({activePage: 1})
    }
    srvs=srvs.slice((activePage-1)*PAGE_SIZE, activePage*PAGE_SIZE)
    
    if (this.state.loading)
      return <Loader/>
    else 
      return <div className="fullpagetab">
      <Header>Internal Anomaly Detection Thresholds</Header>
      <Table compact>
        <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Service Reference Variant</Table.HeaderCell>
          <Table.HeaderCell>Warning Threshold</Table.HeaderCell>
          <Table.HeaderCell>Quarantine Threshold</Table.HeaderCell>
        </Table.Row>
        </Table.Header>
        <Table.Body>
        {srvs.map((srv, i)=>{
          return <Table.Row>
            <Table.Cell>{srv}</Table.Cell>
            <Table.Cell><Input type='number' value={this.state.data[srv].warningThreshold} onChange={(event, data)=>{this.updateWarningThreshold(srv, data.value)}}/></Table.Cell>
            <Table.Cell><Input type='number' value={this.state.data[srv].quarantineThreshold} onChange={(event, data)=>{this.updateQuarantineThreshold(srv, data.value)}}/></Table.Cell>
            </Table.Row>
        })}
        </Table.Body>
        </Table>
        <Divider/>
        <Pagination activePage={this.state.activePage} totalPages={Math.ceil(Object.keys(this.state.data).length/PAGE_SIZE)} onPageChange={(event, { activePage })=>{this.setState({activePage: activePage})}}/> 
        <Divider/>
        {this.state.uploadFailed && <Message error header="Failed to save ADTs" list={this.state.validationErrors}/>}
        {this.state.uploadSuccess && <Message success header="ADTs successfully saved"/>}
        <Button className='seaglassbutton' onClick={()=>this.saveContent()}>Save</Button>
        <Button className='seaglassbutton' onClick={()=>this.loadContent()}>Reset</Button>
      </div>


  
    }
  }